import { useState, useEffect } from "react";
import React from "react";
import { toast } from 'react-toastify';
import { Link, useNavigate, useParams } from "react-router-dom";
import moment from 'moment';
import Pagination from '@mui/material/Pagination';
import { API_VENTAS } from '../shared/services/ventas';
import Header from '../shared/components/Header';
import { faMoneyCheck, faMobileAlt, faTruck, faLink, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InfoModal from "../shared/components/InfoModal";
import HistoricoVenta from "./components/HistoricoVenta";
import VentaEstadosForm from "./components/VentaEstadosForm";
import VentaFacturaProvForm from "./components/VentaFacturaProvForm";
import FacturasProveedorLista from "./components/FacturasProveedorLista";
import { faCcVisa, faPaypal, faWeebly } from "@fortawesome/free-brands-svg-icons";
import { API_FACTURAS } from "../shared/services/facturas";
import IncidenciaForm from "./components/IncidenciaForm";
import NotaCargoForm from "./components/NotaCargoForm";
import { API_INCIDENCIAS } from "../shared/services/incidencias";
import { NOTAS_CARGO_API } from "../shared/services/nota_cargo";
import { useDispatch, useSelector } from "react-redux";
import { fetchVentas } from "../../../../redux/ventas";
import { isBoolean, setErrorMessage } from "../shared/helpers/functionalities";
import { API_ENVIOS } from "../shared/services/envios";
import ConfirmModal from "../shared/components/ConfirmModal";
import PendientesList from "./components/PendientesList";
import ActionsMenu from "../shared/components/ActionsMenu";
import { getActions } from "./actions";
import EditForm from "./components/EditForm";
import config from '../../../../config';
import { fetchVentasPendientes } from '../../../../redux/ventasPendientes';

export default function Ventas() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { page } = useParams();
  const currPage = parseInt(page);
  const [currentPage, setPage] = useState(currPage);
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const [isStateUpdate, setIsStateUpdate] = useState(false);
  const [isUploadProviderInvoice, setIsUploadProviderInvoice] = useState(false);
  const [isMultipleProviderInvoice, setIsMultipleProviderInvoice] = useState(false);
  const [isIncidencia, setIsIncidencia] = useState(false);
  const [openNotaCargo, setOpenNotaCargo] = useState(false);
  const [selectedVenta, setSelectedVenta] = useState(null);
  const [selectedPieza, setSelectedPieza] = useState(null);
  const [selectedEnvio, setSelectedEnvio] = useState(null);
  const [isOpenConfirmEnviosPendientes, setIsOpenConfirmEnviosPendientes] = useState(false);
  const [isOpenConfirmEnviarEmailProveedor, setIsOpenConfirmEnviarEmailProveedor] = useState(false);
  const [isOpenConfirmEnvioFormularioIncidencia, setIsOpenConfirmEnvioFormularioIncidencia] = useState(false);
  const [isEditFormVisible, setIsEditFormVisible] = useState(false);
  const [isOpenConfirmEnvioRecogeCliente, setIsOpenConfirmEnvioRecogeCliente] = useState(false);
  const estados = useSelector(state => state.estados_venta);
  const ventas = useSelector(state => state.ventas);
  const searcher = useSelector(state => state.search)
  const pendientes = useSelector((state) => state.ventas_pendientes);
   
  useEffect(() => {
    dispatch(fetchVentas(false, currPage, getQuery()));
  }, [searcher]);

  useEffect(() => {
    if (!pendientes) dispatch(fetchVentasPendientes());
  }, [pendientes, dispatch]);

  const getQuery = () => {
    const isEmpty = Object.values(searcher).every(x => x === null || x === '');
    let query = !isEmpty ? 'search=' + (searcher?.search ? searcher?.search : '') 
      + (searcher?.start_date ? '&start_date=' + searcher?.start_date : '')
      + (searcher?.end_date ? '&end_date=' + searcher?.end_date : '')
      + (searcher?.min ? '&min=' + searcher?.min : '')
      + (searcher?.max ? '&max=' + searcher?.max : '')
      + (searcher?.responsable ? '&responsable=' + searcher?.responsable : '')
      + (searcher?.plataforma ? '&plataforma=' + searcher?.plataforma : '')
      + (searcher?.desguace ? '&desguace=' + searcher?.desguace : '')
      + (searcher?.tipo_pago ? '&tipo_pago=' + searcher?.tipo_pago : '')
      + (isBoolean(searcher.confirmacion) ? '&confirmacion=' + searcher?.confirmacion : '')
    : null;
    return query;
  }

  const handleSearch = (search, searchData) => {
    setPage(1);
    navigate(`/ventas/${1}`);
    dispatch({type: "search/set", payload: searchData});    
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    navigate(`/ventas/${newPage}`);
    dispatch(fetchVentas(false, newPage, getQuery()));
  }

  const getPaginationCount = () => {
    var totalPages = ventas?.total_items < 15 ? 1 : Math.ceil(ventas?.total_items / 15);
    return totalPages ? parseInt(totalPages) : 0;
  }

  const handleAction = (action, venta) => {
    if(action === 'edit') {
      handleEdit(venta)
    } else if(action === 'status') {
      handleEditState(venta)
    } else  if(action === 'provider-invoice') {
      handleEditProviderInvoice(venta)
    } else  if(action === 'history') {
      handleViewHistory(venta)
    } else  if(action === 'download') {
      generateThePdf(venta)
    } else if(action === 'refund') {
      handleNewRefund(venta)
    } else if(action === 'issue') {
      handleIncidencia(venta)
    } else if(action === 'shipment-note') {
      handleOpenNotaCargo(venta)
    } else if(action === 'incidencia-form-mail') {
      handleOpenConfirmEnvioFormularioIncidencia(venta)
    } else if (action === 'incidencia-form-phone') {
      handleCopyFormularioIncidenciaText(venta)
    } else if (action === 'email-recoge-cliente') {
      handleOpenConfirmRecogeCliente(venta)
    }
  }

  const handleOpenConfirmEnvioFormularioIncidencia = (venta) => {
    setSelectedVenta(venta);
    setIsOpenConfirmEnvioFormularioIncidencia(true);
  }
  const handleCloseConfirmEnvioFormularioIncidencia = () => {
    setIsOpenConfirmEnvioFormularioIncidencia(false);
    setSelectedVenta(null);
  }
  const handleConfirmEnvioFormularioIncidencia = async(confirm) => {
    if(confirm) {
      const response = await API_VENTAS.enviarEmailFormularioIncidencia(selectedVenta.id);

      if(response && response.success) {
        toast.success(response.message);
      }
    }

    handleCloseConfirmEnvioFormularioIncidencia();
  }
  
  const handleOpenConfirmRecogeCliente = (venta) => {
    setSelectedVenta(venta);
    setIsOpenConfirmEnvioRecogeCliente(true);
  }
  
  const handleConfirmEnvioRecogeCliente = async(confirm) => {
    if(confirm) {
      const response = await API_VENTAS.enviarEmailRecogeCliente(selectedVenta.presupuesto.numero);

      if(response && response.success) {
        toast.success('Email recogida cliente enviado');
      }
    }

    setIsOpenConfirmEnvioRecogeCliente(false);
    setSelectedVenta(null);
  }

  const handleCopyFormularioIncidenciaText = (venta) => {
    const text = `Hola ${venta?.cliente?.nombre},

Hemos recibido tu solicitud de asistencia. Para agilizar el proceso, por favor completa el formulario de incidencias en el siguiente enlace:

${config.recomotor.landingUrl + `/solicitudes-vo/${venta?.id}/incidencia`}
    
Si necesitas asistencia adicional, no dudes en contactarnos. Agradecemos tu paciencia.`;

    navigator.clipboard.writeText(text);
    toast.success('Texto copiado!');
  }

  const handleEdit = (venta) => {
    setIsEditFormVisible(true);
    setSelectedVenta(venta);
  }

  const handleEditState = (venta) => {
    setIsStateUpdate(true);
    setSelectedVenta(venta);
  } 

  const handleEditProviderInvoice = (venta) => {
    setIsUploadProviderInvoice(true);
    setSelectedVenta(venta);
  } 

  const handleCloseHistory = () => setIsHistoryOpen(false);
  const handleCloseEstado = () => setIsStateUpdate(false);
  const handleCloseUploadInvoice = () => setIsUploadProviderInvoice(false);
  const handleCloseDownloadProviderInvoices = () => setIsMultipleProviderInvoice(false);
  const handleCloseNuevaIncidencia = () => setIsIncidencia(false);

  const handleOpenNotaCargo = (venta) => {
    setSelectedVenta(venta);
    setOpenNotaCargo(true);
  }
  const handleCloseNotaCargo = () => {
    setOpenNotaCargo(false);
    setSelectedVenta(null);
  }
  const handleNewNotaCargo = async(data) => {
    dispatch({type: 'loading/set', payload: true});

    data.forEach(async(nota) => {
      const notaResult = await NOTAS_CARGO_API.new(nota)
      .catch(function (error) {
        dispatch({type: 'loading/set', payload: false});
        toast.error(setErrorMessage(error))
      });

      if(notaResult && notaResult.data) {
        toast.success(`${data.length > 1 ? 'Notas de cargo creadas ' : 'Nota de cargo creada '} correctamente!`)
      }
    })

    dispatch({type: 'loading/set', payload: false});
    setIsIncidencia(false);
    navigate('/notas-cargo/1')
  }

  const handleViewHistory = (venta) => {
    setIsHistoryOpen(true);
    setSelectedVenta(venta);
  }

  const downloadInvoice = async (invoice) => {
    dispatch({type: 'loading/set', payload: true});
    const invoiceResult = await API_VENTAS.downloadProviderInvoice(invoice.factura_proveedor);

    if(invoiceResult) {
      dispatch({type: 'loading/set', payload: false});
      const url = window.URL.createObjectURL(new Blob([invoiceResult], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', invoice.factura_proveedor); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
  }

  const handleUploadProviderInvoice = async (data) => {
    const files = data.factura_proveedor;
    let facturasProveedor = new FormData();
    facturasProveedor.append('id', selectedVenta.id);

    if(files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        facturasProveedor.append(`files[${i}]`, files[i])
      }

      dispatch({type: 'loading/set', payload: true});
      const uploadProviderInvoicesResult = await API_VENTAS.uploadProviderInvoice(facturasProveedor, selectedVenta.id)
      .catch(function (error) {
        dispatch({type: 'loading/set', payload: false});
        toast.error(setErrorMessage(error))
      });

      if(uploadProviderInvoicesResult && uploadProviderInvoicesResult.success && uploadProviderInvoicesResult.data) {
        dispatch({type: 'loading/set', payload: false});
        toast.success(uploadProviderInvoicesResult.message)
        setIsUploadProviderInvoice(false);
        let query = getQuery;
        dispatch(fetchVentas(false, currPage, query));
      }
    }
  }

  const getEstadoName = (estadoId) => estados.find(u => u.id === estadoId)?.nombre;

  const handleViewDevoluciones = () => { 
    localStorage.removeItem('searcher');
    navigate('/devoluciones/1');
  }

  const handleUpdateEstado = async (data) => {
    dispatch({type: 'loading/set', payload: true});
    let response; 

    if(data?.piezas?.length > 0) {
      await Promise.all(data?.piezas.map(p => API_VENTAS.updateVenta({
        id: data.id,
        estado_venta_id: data.estado_venta_id, 
        pieza_id: p.pieza_id,
        codigo_pedido: p.codigo_pedido,
        tipo_pedido: p.tipo_pedido,
        comentario: p.comentario
      }))).then(res => {
          if(res) {
            dispatch({type: 'loading/set', payload: false});
            toast.success(res[0]?.message)
            setIsStateUpdate(false);
            dispatch(fetchVentas(false, currPage, getQuery()));
          }
      });
    } else {
      response = await API_VENTAS.updateVenta(data)
      .catch(function (error) {
        dispatch({type: 'loading/set', payload: false});
        toast.error(setErrorMessage(error))
      });

      if(response && response.success) {
        dispatch({type: 'loading/set', payload: false});
        toast.success(response.message)
        setIsStateUpdate(false);
        dispatch(fetchVentas(false, currPage, getQuery()));
      }
    } 
  }

  const generateThePdf = async (venta) => {
    dispatch({type: 'loading/set', payload: true});
    const pdfResult = await API_FACTURAS.generateFacturaPDF(venta.factura_id);

    if(pdfResult) {
      window.open(pdfResult.data, "_blank");
    } else {
      toast.error('Ups! Algo ha ido mal...')
    }
    dispatch({type: 'loading/set', payload: false});
  } 

  const handleNewRefund = (venta) => { navigate('/devolucion/0', { state : { ventaId: venta.id }, replace : true}); }

  const handleIncidencia = (venta) => {
    setSelectedVenta(venta);
    setIsIncidencia(true);
  }

  const handleSubmitIncidencia = async (data) => {
    dispatch({type: 'loading/set', payload: true});

    data.forEach(async(incidencia) => {
      const incidenciaResult = await API_INCIDENCIAS.newIncidencia(incidencia)
      .catch(function (error) {
        dispatch({type: 'loading/set', payload: false});
        toast.error(setErrorMessage(error))
      });

      if(incidenciaResult && incidenciaResult.data) {
        toast.success(`${data.length > 1 ? 'Incidencias creadas ' : 'Incidencia creada '} correctamente!`)
      }
    })

    dispatch({type: 'loading/set', payload: false});
    setIsIncidencia(false);
    navigate('/incidencias/1')
  }

  const handleGoToPresupuestos = (id) => {
    navigate('/presupuesto/' + id, { replace : true});
  }

  const handleGoToEnvio = (envio) => {
    dispatch({type: "search/set", payload: {search: envio.codigo_transporte }});
    navigate('/envios/1', { replace : true});
  }

  const handleOpenConfirmEnviosPendientes = (venta, pieza, envio) => {
    if(venta && pieza) {
      setSelectedVenta(venta);
      setSelectedPieza(pieza);
    } else {
      setSelectedEnvio(envio);
    }
    
    setIsOpenConfirmEnviosPendientes(true);
  }
  const handleCloseEnviosPendientes = () => {
    setSelectedVenta(null);
    setSelectedPieza(null);
    setSelectedEnvio(null);
    setIsOpenConfirmEnviosPendientes(false);
  } 

  const handleOpenConfirmEnvioEmailProveedor = (envio) => {
    setSelectedEnvio(envio);
    setIsOpenConfirmEnviarEmailProveedor(true);
  }
  const handleCloseEnvioEmailProveedor = () => {
    setSelectedEnvio(null);
    setIsOpenConfirmEnviarEmailProveedor(false);
  } 

  const handleCreateEnvioPendiente = async(confirm) => {
    if(confirm) {
      dispatch({type: 'loading/set', payload: true});
      let response;

      if(selectedVenta && selectedPieza) {
        response = await API_ENVIOS.regenerarEnvioPendiente({
          presupuesto_id: selectedVenta.presupuesto_id,
          servicio_envio_id: selectedPieza.servicio_envio.id
        }).catch(function (error) {
          dispatch({type: 'loading/set', payload: false});
          toast.error(setErrorMessage(error))
        });
      } else {
        response = await API_ENVIOS.regenerarEnvioPendiente({
          envio_id: selectedEnvio.id
        }).catch(function (error) {
          dispatch({type: 'loading/set', payload: false});
          toast.error(setErrorMessage(error))
        });
      }
    
      if(response && response.success) {
        dispatch({type: 'loading/set', payload: false});
        toast.success(response.message)
        dispatch(fetchVentas(false, currPage, getQuery()));
      }
    } 

    handleCloseEnviosPendientes();
  }

  const handleEnviarEmailProveedor = async(confirm) => {
    if(confirm) {
      dispatch({type: 'loading/set', payload: true});
      const response = await API_ENVIOS.enviarEmailProveedor(selectedEnvio.id)
      .catch(function (error) {
        dispatch({type: 'loading/set', payload: false});
        toast.error(setErrorMessage(error))
      });
  
      if(response && response.success) {
        dispatch({type: 'loading/set', payload: false});
        toast.success(response.message)
        dispatch(fetchVentas(false, currPage, getQuery()));
      }
    }

    handleCloseEnvioEmailProveedor();
  }

  const updateCurrentDesguace = (desguace, sidegal) => {
    if (sidegal) { 
      localStorage.setItem('currentDesguace', JSON.stringify(3));
      return;
    }
    localStorage.setItem('currentDesguace', JSON.stringify(desguace));
  }

  //<button className="btn btn-default" onClick={handleViewVentas}>{isArchived ? 'No archivadas' : 'Archivadas'}</button>
    
  const getIncidenciaColor = (estadoId) => {
    if(Number(estadoId) === 4) return '#62B1F6';
    if(Number(estadoId) === 1) return '#FF8000 ';
    if(Number(estadoId) === 3) return '#9D00FF';
  }

  
  return (
    <div className="content pt-3">
      <div className="w-100 d-flex flex-wrap align-items-end justify-content-between">
        <Header viewSearch={true} onSearch={handleSearch}></Header>
        <button className="btn btn-default" onClick={handleViewDevoluciones}>Devoluciones</button>
      </div>

      <div className="w-100 d-flex flex-column align-items-end content-table">
        <div className="w-100 d-flex flex-wrap flex-md-nowrap align-items-end justify-content-between mb-3">
          <div className="flex-grow-1 d-flex align-items-center justify-content-between justify-content-md-start me-5">
            <div className="legend d-flex align-items-center me-md-3">
              <span className="circle" style={{background: '#ffc107'}}></span>
              <p>Devolución parcial</p>
            </div>

            <div className="legend d-flex align-items-center me-md-3">
              <span className="circle" style={{background: '#dc3545'}}></span>
              <p>Devolución total</p>
            </div>

            <div className="legend d-flex align-items-center me-md-3">
              <span className="circle" style={{background: getIncidenciaColor(4)}}></span>
              <p>Incidencia pendiente validación</p>
            </div>
            
            <div className="legend d-flex align-items-center me-md-3">
              <span className="circle" style={{background: getIncidenciaColor(1)}}></span>
              <p>Incidencia en curso</p>
            </div>
            
            <div className="legend d-flex align-items-center">
              <span className="circle" style={{background: getIncidenciaColor(3)}}></span>
              <p>Incidencia finanzas</p>
            </div>
          </div>
        </div>

        { (pendientes?.length > 0) &&
          <PendientesList 
          pendientes={pendientes}
          />
        }

        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>pres</th>
                <th className="text-center">fecha</th>
                <th>cliente</th>
                <th>telf</th>
                <th><small>Pieza</small></th>
                <th className="text-center"><small>compra</small></th>
                <th className="text-center"><small>venta</small></th>
                <th className="text-center"><small>casco</small></th>
                <th className="text-center">descuento</th>
                <th className="text-center">total IVA</th>
                <th className="text-center">margen bruto</th>
                <th className="text-center">envio</th>
                <th className="text-center">CONF</th>
                <th className="text-center">estado</th>
                <th className="text-center">pago</th>
                <th className="text-center">resp</th>
                <th className="text-center"></th>
              </tr>
            </thead>

            { ventas.ventas?.map((venta, index) => {
                const piezasValues = Object.values(venta.piezas)
                const piezasRows = piezasValues.map((pieza, i) => {
                  const envioPieza = venta?.envios?.length > 0 ? venta?.envios?.find(e => e?.piezas.find(p => p.id === pieza.id)) : null;

                  const presupuesto = i === 0 ? <td rowSpan={piezasValues.length + 1} width="5%">
                    <span className="link" title="Presupuesto" onClick={() => handleGoToPresupuestos(venta?.presupuesto?.id)} >
                      { venta.incidencia_estado ?
                        <b style={{ color: getIncidenciaColor(venta.incidencia_estado)}}>{venta.presupuesto?.numero}</b>
                        : venta.es_devolucion.length > 0 && venta.es_devolucion[0].tipo_devolucion_id === 1 ?
                        <b className="text-warning">{venta.presupuesto?.numero}</b>
                        : venta.es_devolucion.length > 0 && venta.es_devolucion[0].tipo_devolucion_id === 2 ?
                        <b className="text-danger">{venta.presupuesto?.numero}</b>
                        : venta.factura_proveedor && venta.factura_proveedor?.length > 0 ?
                        <b>{venta.presupuesto?.numero}</b>
                        : venta.presupuesto?.numero
                      }
                    </span>
                    
                  </td> : null
                  const fecha = i === 0 ?  <td rowSpan={piezasValues.length + 1} width="12%" className="text-center">
                    <div className="w-100 d-flex flex-column">
                      <p>{moment(venta.fecha).format("DD-MM-YYYY")}</p>
                      <small>CREADO: {moment(venta.created_at).format("DD-MM-YYYY HH:mm")}</small>
                      <small>ULT MOD.: {moment(venta.updated_at).format("DD-MM-YYYY HH:mm")}</small>
                    </div>
                  </td> : null
                  const cliente = i === 0 ?  <td rowSpan={piezasValues.length + 1} width="12%">
                    <Link target="_blank" rel="noopener noreferrer" to={`/cliente/${venta.cliente?.id}`} title="Ficha Cliente" className="text-green text-uppercase">
                      {venta.cliente?.nombre}
                    </Link>
                  </td> : null
                  const clienteTelf = i === 0 ?  <td rowSpan={piezasValues.length + 1}>{venta.cliente.telefono}</td> : null
                  const pago = i === 0 ?  <td rowSpan={piezasValues.length + 1} className="text-center" width={"6%"}> 
                    { venta.tipo_pago_id === 1 ?
                      <span title="Tarjeta">
                        <FontAwesomeIcon icon={faCcVisa} size="1x" className="action" color="#215732" />
                      </span>
                      
                      : venta.tipo_pago_id === 2 ?
                      <span title="Bizum">
                        <FontAwesomeIcon icon={faMobileAlt} size="1x" className="action" color="#215732" />
                      </span>
                      
                      : venta.tipo_pago_id === 3 ?
                      
                      <span title="Transferencia">
                        <FontAwesomeIcon icon={faMoneyCheck} size="1x" className="action" color="#215732" />
                      </span>

                      : venta.tipo_pago_id === 4 ?

                      <span title="Crédito">
                        <b className="text-success">C</b>
                      </span>

                      : venta.tipo_pago_id === 5 ?
                      <div className="d-flex flex-column">
                        <span title="Venta Online">
                          <FontAwesomeIcon icon={faWeebly} size="1x" className="action" color="#215732" />
                        </span>
                        <small className="fw-bold text-uppercase">{venta?.plataforma?.nombre}</small>
                        <small className="text-uppercase">{venta?.codigo_pedido}</small>
                      </div>

                      : venta.tipo_pago_id === 6 ?
                      <span title="PayPal">
                        <FontAwesomeIcon icon={faPaypal} size="1x" className="action" color="#215732" />
                      </span>
                      
                      : 'no especificado'
                    }
                  </td> : null
                  const descuento = i === 0 ? <td rowSpan={piezasValues.length + 1} className="text-center">
                    { (venta?.vale_descuento || venta?.codigo_descuento_masivo) ? 
                      <div className="d-flex flex-column">
                        -{parseFloat(venta.total_descuento_iva > 0 ? venta.total_descuento_iva : venta.total_descuento).toFixed(2)}€
                        <span className="fw-bold text-green">{venta?.vale_descuento?.codigo || venta?.codigo_descuento_masivo}</span>
                      </div>
                      : '-'
                    }
                  </td> : null
                  const totalIva = i === 0 ? <td rowSpan={piezasValues.length + 1} width="6%" className="text-center">{parseFloat(venta.total_iva).toFixed(2)}</td> : null
                  const envio = envioPieza ?
                        <div className="d-flex flex-column">
                          { envioPieza.numero_seguimiento !== '' ?
                            <>
                              <span onClick={() => handleGoToEnvio(envioPieza)} className="text-green link">{envioPieza.codigo_transporte}</span>
                              <small>{envioPieza.transportista_id === 1 && envioPieza.numero_seguimiento === '-' ? 'PROVEEDOR' : envioPieza.numero_seguimiento}</small>
                              <a title="Seguimiento URL" href={config.recomotor.clientsUrl + 'seguimiento/' + venta.presupuesto.checkout_id} target={"_blank"}  className="disabled-item mt-2 text-green" rel="noreferrer">
                                <FontAwesomeIcon icon={faLink} size="1x" className="action" style={{ cursor: 'pointer' }} color="#215732" />
                              </a> 
                              <span title="Enviar email proveedor" style={{cursor: 'pointer'}}>
                                <FontAwesomeIcon icon={faEnvelope} size="1x" className="action" color="#215732" onClick={() => handleOpenConfirmEnvioEmailProveedor(envioPieza)} />
                              </span>
                            </>
                          :
                          <span title="Generar envio pendiente" style={{cursor: 'pointer'}}>
                            <FontAwesomeIcon icon={faTruck} size="1x" className="action" color="#215732" onClick={() => handleOpenConfirmEnviosPendientes(null, null, envioPieza)} />
                          </span>
                          }
                        </div>
                        : 
                        <div className="w-100">
                          <span title="Generar envio pendiente" style={{cursor: 'pointer'}}>
                            <FontAwesomeIcon icon={faTruck} size="1x" className="action" color="#215732" onClick={() => handleOpenConfirmEnviosPendientes(venta, pieza)} />
                          </span>
                        </div>
                  const confirmada = <span className={"fw-bold " + (pieza.confirmacion == true ? 'text-green' : 'text-danger')}>
                      {pieza.confirmacion == true ? 'SI' : 'NO'}
                    </span>
                  const beneficio = i === 0 ? <td rowSpan={piezasValues.length + 1} className="text-center">{parseFloat(venta.beneficio).toFixed(2)}</td> : null
                  const estado = i === 0 ?  <td rowSpan={piezasValues.length + 1}  className="text-center text-uppercase"><small>{getEstadoName(venta.estado_venta_id)}</small></td> : null
                  const responsable = i === 0 ?  <td rowSpan={piezasValues.length + 1}  className="text-center text-uppercase" width="6%"><small>{venta.created_by?.username}</small></td> : null
                  const acciones = i === 0 ?  <td rowSpan={piezasValues.length + 1} className="text-center">
                    <ActionsMenu 
                        options={getActions(venta)}
                        onAction={(action) => handleAction(action, venta)}
                    />
                  </td> : null
                      
                  return (
                    <tr key={i} className={!venta.revisado ? 'not-viewed' : ''}>
                      {presupuesto}
                      {fecha}
                      {cliente}
                      {clienteTelf}
                      <td>
                        <div className="w-100 d-flex flex-column text-uppercase">
                          <small className="w-100 d-flex flex-column">
                            <span>
                              {pieza?.venta_relationship?.unidades > 1 ? 
                                <strong>{'x'+pieza?.venta_relationship?.unidades}</strong> : '' 
                              } 
                              {pieza.nombre}
                            </span>
                            <span>ID: <b>{pieza.id_referencia_plataforma}</b></span>
                            <span>REF: <b>{pieza.referencia_pieza}</b></span>
                            { pieza?.casco > 0 ?
                              <span className="fw-bold text-uppercase highlight"><small>contiene casco</small></span>
                              : ''
                            }
                          </small>

                          <Link target="_blank" rel="noopener noreferrer" to={`/proveedor/${pieza.proveedor?.id}`} title="Ficha Proveedor" className="text-green text-uppercase" onClick={() => updateCurrentDesguace(pieza.desguace?.id, !pieza.desguace?.nombre ? true : false)}>
                            {pieza.desguace?.nombre || 'Otros'}
                          </Link>
                        </div>
                      </td>
                      <td className="text-center">{parseFloat(pieza.precio_compra).toFixed(2)}€</td>
                      <td className="text-center">{parseFloat(pieza.precio_venta).toFixed(2)}€</td>
                      <td className="text-center">{pieza.casco > 0 ? parseFloat(pieza.casco).toFixed(2) + '€' : '-'}</td>
                      {descuento}
                      {totalIva}
                      {beneficio}
                      <td className="text-center">{envio}</td>
                      <td className="text-center">{confirmada}</td>
                      {estado}
                      {pago}
                      {responsable}
                      {acciones}
                    </tr>
                  )
                })
                return (
                  <tbody key={index}>
                    {piezasRows}
                  </tbody>
                )
              }) 
            }
          </table>
        </div>

        <Pagination 
          className="mt-3" 
          count={getPaginationCount()} 
          page={currentPage} 
          onChange={handleChangePage} 
        />
      </div>

      { isStateUpdate && 
        <InfoModal
          state={isStateUpdate}
          title="Cambiar estado"
          content={<VentaEstadosForm venta={selectedVenta} onSubmitEstado={handleUpdateEstado} />}
          onClose={handleCloseEstado}
        ></InfoModal>
      }

      { isUploadProviderInvoice && 
        <InfoModal
          state={isUploadProviderInvoice}
          title="Adjuntar factura/s de proveedor"
          content={<VentaFacturaProvForm venta={selectedVenta} onSubmitVenta={handleUploadProviderInvoice} />}
          onClose={handleCloseUploadInvoice}
        ></InfoModal>
      }

      { isHistoryOpen && 
        <InfoModal
          width={'md'}
          state={isHistoryOpen}
          title="Historico de venta"
          content={<HistoricoVenta historico={selectedVenta.historico} />}
          onClose={handleCloseHistory}
        ></InfoModal>
      }

      { isMultipleProviderInvoice && 
        <InfoModal
          state={isMultipleProviderInvoice}
          title="Facturas de proveedor"
          content={<FacturasProveedorLista venta={selectedVenta} onDownloadInvoice={downloadInvoice} />}
          onClose={handleCloseDownloadProviderInvoices}
        ></InfoModal>
      }

      { isIncidencia && 
        <InfoModal
          state={isIncidencia}
          title="Nueva Incidencia"
          content={<IncidenciaForm venta={selectedVenta} onSubmitIncidencia={handleSubmitIncidencia} />}
          width={'lg'}
          onClose={handleCloseNuevaIncidencia}
        ></InfoModal>
      }

      { openNotaCargo &&
        <InfoModal
          state={openNotaCargo}
          title="Nueva Nota de cargo"
          content={
            <NotaCargoForm
              venta={selectedVenta}
              onSubmitNota={handleNewNotaCargo}
            />
          }
          width={'lg'}
          onClose={handleCloseNotaCargo}
        />
      }

      { isOpenConfirmEnviosPendientes && 
          <ConfirmModal 
              onConfirmAction={handleCreateEnvioPendiente} 
              title={'Regenerar envio pendiente'} 
              description={'Estás seguro de regenerar el envio pendiente?'}
              state={isOpenConfirmEnviosPendientes}>
          </ConfirmModal>
      }

      { isOpenConfirmEnviarEmailProveedor && 
          <ConfirmModal 
              onConfirmAction={handleEnviarEmailProveedor} 
              title={'Enviar email al proveedor'} 
              description={'Estás seguro de enviar el email al proveedor?'}
              state={isOpenConfirmEnviarEmailProveedor}>
          </ConfirmModal>
      }

      { isOpenConfirmEnvioFormularioIncidencia &&
        <ConfirmModal 
              onConfirmAction={handleConfirmEnvioFormularioIncidencia} 
              title={'Enviar email de formulario de incidencia'} 
              description={'Estás seguro de enviar el email?'}
              state={isOpenConfirmEnvioFormularioIncidencia}>
          </ConfirmModal>
      }
      
      { isOpenConfirmEnvioRecogeCliente &&
        <ConfirmModal 
            onConfirmAction={handleConfirmEnvioRecogeCliente} 
            title={'Enviar email de recogida cliente'} 
            description={'Estás seguro de enviar el email?'}
            state={isOpenConfirmEnvioRecogeCliente}>
        </ConfirmModal>
      }

      { isEditFormVisible &&
        <InfoModal
          state={isEditFormVisible}
          title="Editar venta"
          onClose={() => setIsEditFormVisible(false)}
          width={'md'}
          content={
            <EditForm 
              venta={selectedVenta} 
              onActionDone={() => {
                dispatch(fetchVentas(false, currPage, getQuery()));
                setIsEditFormVisible(false);
              }} 
            />
          }
        />
      }
    </div>
  )
}